import { Grid } from "antd";


export const getBreakpoint = () => {
    const { useBreakpoint } = Grid;
// const screens = useBreakpoint();
    return useBreakpoint
}